import React from 'react';
import './Widget.css';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { fetchWeather1 } from './FetchWeather';
import moment from 'moment';
import sunrise from './icons/sunrise.png';
import sunset from './icons/sunset.png';
import moonrise from './icons/moonrise.png';
import moonset from './icons/moonset.png';

function Widget(props) {
    let time= props.weatherData.data.location.localtime;
    let time1 = time.slice(-5);
    time1 = time1.substring(0, time1.length - 3);

    let dt = moment(props.weatherData.data.forecast.forecastday[1].date);
    let dt1 = moment(props.weatherData.data.forecast.forecastday[2].date);
    
    
    return (
        
        <div className="widget" style={{color:((props.weatherData.data.current.is_day===1)||(props.weatherData.data.current.condition.text).toLowerCase().includes ('drizzle')||(props.weatherData.data.current.condition.text).toLowerCase().includes ('rain')) ?'black':'white'}}>
            
            <div className="currentTemp">
                { Math.round(props.weatherData.data.current.temp_c)}<sup>&deg;C</sup> 
            </div>
            <div className="maxmintemp">
            <strong>{Math.round(props.weatherData.data.forecast.forecastday[0].day.maxtemp_c)}<sup>&deg;</sup></strong> /  {Math.round(props.weatherData.data.forecast.forecastday[0].day.mintemp_c)}<sup>&deg;</sup>
            </div>
            <div className="currentWeather">
                   {props.weatherData.data.current.condition.text} 
            </div>
            <div className="location">
            <LocationOnOutlinedIcon/>
                {props.weatherData.data.location.name} , {props.weatherData.data.location.country} 
            </div>

            <div className="hourly">
                <div className="currentitems">
                    <p>Now</p>
                    <img src={props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.current.temp_c)}<sup>&deg;</sup> </p>
                </div>
                <div className="currentitems">
                   
                {(23-(parseInt(time1)+1)) <0 ?
                    <>
                    <p>{Math.abs(23-(parseInt(time1)+1))-1 +   ':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+1)-1))].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+1)-1))].temp_c)}<sup>&deg;</sup></p>
                    </>
                    :
                    <>
                    <p>{parseInt(time1)+1+':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+1].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+1].temp_c)}<sup>&deg;</sup></p>
                    </>
                     }
                </div>
                <div className="currentitems">
                {(23-(parseInt(time1)+2)) <0 ?
                    <>
                    <p>{Math.abs(23-(parseInt(time1)+2))-1 +   ':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+2)-1))].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+2)-1))].temp_c)}<sup>&deg;</sup></p>
                    </>
                    :
                    <>
                    <p>{parseInt(time1)+2+':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+2].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+2].temp_c)}<sup>&deg;</sup></p>
                    </>
                     }
                </div>
                <div className="currentitems">
                {(23-(parseInt(time1)+3)) <0 ?
                    <>
                    <p>{Math.abs(23-(parseInt(time1)+3))-1 +   ':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+3)-1))].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+3)-1))].temp_c)}<sup>&deg;</sup></p>
                    </>
                    :
                    <>
                    <p>{parseInt(time1)+3+':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+3].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+3].temp_c)}<sup>&deg;</sup></p>
                    </>
                     }
                </div>
                <div className="currentitems">
                {(23-(parseInt(time1)+4)) <0 ?
                    <>
                    <p>{Math.abs(23-(parseInt(time1)+4))-1 +   ':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+4)-1))].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[1].hour[((Math.abs(23-parseInt(time1)+4)-1))].temp_c)}<sup>&deg;</sup></p>
                    </>
                    :
                    <>
                    <p>{parseInt(time1)+4+':00'}</p>
                    <img src={props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+4].condition.icon}/>
                    <p>{Math.round(props.weatherData.data.forecast.forecastday[0].hour[parseInt(time1)+4].temp_c)}<sup>&deg;</sup></p>
                    </>
                     }
                </div>
            </div>
            <div >
                <div className="daily">
                    <p><strong>{dt.format('dddd')},{dt.format('MMMM').substring(0,3)}.{dt.format('D')}</strong></p>
                   <img src= {props.weatherData.data.forecast.forecastday[1].day.condition.icon} />
                   <p><strong>{Math.round(props.weatherData.data.forecast.forecastday[1].day.maxtemp_c)}<sup>&deg;</sup></strong>/{Math.round(props.weatherData.data.forecast.forecastday[1].day.mintemp_c)}<sup>&deg;</sup></p>
                     
                </div>  
                <div className="daily">
                    <p><strong>{dt1.format('dddd')},{dt1.format('MMMM').substring(0,3)}.{dt1.format('D')}</strong></p>
                   <img src= {props.weatherData.data.forecast.forecastday[2].day.condition.icon} />
                   <p><strong>{Math.round(props.weatherData.data.forecast.forecastday[2].day.maxtemp_c)}<sup>&deg;</sup></strong>/{Math.round(props.weatherData.data.forecast.forecastday[2].day.mintemp_c)}<sup>&deg;</sup></p>
                </div>  
            </div>
            <div className="forecastTitle">
                <p>COMFORT LEVEL</p>
            </div>
            <div className="comfort">
                <div>
                    <p>Humidity <span>{props.weatherData.data.current.humidity+'%'}</span></p>
                    
                </div>
                <div>
                    <p>Feels like <span>{Math.round(props.weatherData.data.current.feelslike_c)}<sup>&deg;</sup></span></p>
                    <p>UV Index <span>{props.weatherData.data.current.uv}</span></p>
                </div>
            </div>
            <div className="astroTitle">
                <p>ASTRO</p>
            </div>
            <div className="astro">
                <div className="sun">
                    <div className="astrorise">
                        <img src={sunrise} /> 
                        {props.weatherData.data.forecast.forecastday[0].astro.sunrise}
                    </div>
                    <div className="astroset">
                        <img src={sunset} /> 
                        {props.weatherData.data.forecast.forecastday[0].astro.sunset}
                    </div>
                </div>
                <div className="moon">
                    <div className="astrorise">
                        <img src={moonrise} /> 
                        {props.weatherData.data.forecast.forecastday[0].astro.moonrise}
                    </div>
                    <div className="astroset">
                        <img src={moonset} /> 
                        {props.weatherData.data.forecast.forecastday[0].astro.moonset}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Widget
